import { UtilityService } from '@eforall/common';
import { FilterOperator, GridColumn, buildColumn } from '@eforall/dashboard';
import { CourseEnrollment } from '../enrollments-view.part';
import { ascending } from 'vega';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<CourseEnrollment, unknown>[] = [
		buildColumn(util, 'Id', row => row.personId, { header: 'personId' }),
		buildColumn(util, 'Id', row => row.courseVersionId, { header: 'courseVersionId' }),
		buildColumn(util, 'Id', row => row.accVentureId, { header: 'accVentureId' }),
		buildColumn(util, 'Text', row => row.personFullName, { header: 'Name' }),
		buildColumn(util, 'TrueFalse', row => row.isVentureDroppedOut, { header: 'Dropped Out', hidden: true, filter: { operator: FilterOperator.EqualTo, value: false } }),
		buildColumn(util, 'Text', row => row.ventureName, { header: 'Venture', 
			renderCellClasses: row => row.isVentureDroppedOut ? ['grid-cell-strikethrough', 'grid-cell-red-text'] : [] }),
		buildColumn(util, 'Text', row => row.courseTitle, { header: 'Course Title' }),
		buildColumn(util, 'Percent', row => row.percentComplete, { header: '% Complete', hidden: true }),
		buildColumn(util, 'Text', row => row.status, {
			header: 'Status', headerTooltip: 'Status is based on the current course work due and the entrepreneur’s progress:\n -"On Track": the entrepreneur has comepleted all of last week’s activities and can continue this week’s\n -"Behind": the entrepreneur has not completed all of last week’s activities\n -"Far Behind": the entrepreneur is 2 weeks or more behind on activities and likely requires outreach',
			renderCellClasses: row => row.status == 'Far Behind' ? ['grid-cell-red-text'] : []}),
		buildColumn(util, 'Text', row => row.currentPercentComplete === 100 ? 'Done' : 'Not Done', {
			header: 'This Week', headerTooltip: 'Whether the entrepreneur completed all activities assigned for the current week',
			renderCellClasses: row => row.currentPercentComplete === 100 ? ['grid-cell-green-text'] : []
		}),
		buildColumn(util, 'Percent', row => row.currentPercentComplete, { header: 'Progress to Week', sort: 'asc',
			headerTooltip: 'Percentage of activities completed from the start of the program to the current week', width: 110 }),
		buildColumn(util, 'Percent', row => row.ventureMaxCompletionPercent, { header: 'Venture Max Completion %', hidden: true, headerTooltip: 'The maximum completion percentage of all entrepreneurs from the same venture' }),
		buildColumn(util, 'DateTime', row => util.date.fromUTC(row.enrolledUTC), { header: 'Enrolled', hidden: true, headerTooltip: 'The date the entrepreneur was enrolled in the course' }),
		buildColumn(util, 'DateTime', row => row.updatedUTC !== row.enrolledUTC ? util.date.fromUTC(row.updatedUTC) : undefined, { header: 'Last Activity' }),
		buildColumn(util, 'DateTime', row => row.completedUTC ? util.date.fromUTC(row.completedUTC) : undefined, { header: 'Completed' }),
	];


	return columns;

} 